export default {
  centerCity: [
    {
      id: 1,
      label: 'Thomas Jefferson University Hospital',
      url: 'http://hospitals.jefferson.edu/?utm_source=jefferson&utm_medium=nav&utm_campaign=healthsystem'
    },
    {
      id: 2,
      label: 'Jefferson Hospital for Neuroscience',
      url: 'http://hospitals.jefferson.edu/departments-and-services/jefferson-hospital-for-neuroscience.html?utm_source=jefferson&utm_medium=nav&utm_campaign=healthsystem'
    },
    {
      id: 3,
      label: 'Methodist Hospital',
      url: 'https://hospitals.jefferson.edu/find-a-location/locations/jefferson-methodist-hospital.html?utm_source=jefferson&utm_medium=nav&utm_campaign=healthsystem'
    },
    {
      id: 4,
      label: 'Magee Rehabilitation',
      url: 'http://mageerehab.org/?utm_source=jefferson&utm_medium=nav&utm_campaign=healthsystem'
    }
  ],
  abbington: [
    {
      id: 1,
      label: 'Abington - Jefferson Health',
      url: 'https://www.abingtonhealth.org/?utm_source=jefferson&utm_medium=nav&utm_campaign=healthsystem'
    },
    {
      id: 2,
      label: 'Abington - Lansdale Hospital Jefferson Health',
      url: 'https://www.abingtonhealth.org/our-locations/abington-lansdale-hospital/?utm_source=jefferson&utm_medium=nav&utm_campaign=healthsystem'
    }
  ],
  northEast: [
    {
      id: 1,
      label: 'Jefferson Bucks Hospital',
      url: 'https://www.ariahealth.org/bucks-county?utm_source=jefferson&utm_medium=nav&utm_campaign=healthsystem'
    },
    {
      id: 2,
      label: 'Jefferson Frankford Hospital',
      url: 'https://www.ariahealth.org/frankford?utm_source=jefferson&utm_medium=nav&utm_campaign=healthsystem'
    },
    {
      id: 3,
      label: 'Jefferson Torresdale Hospital',
      url: 'https://www.ariahealth.org/torresdale?utm_source=jefferson&utm_medium=nav&utm_campaign=healthsystem'
    }
  ],
  newJersey: [
    {
      id: 1,
      label: 'Jefferson Cherry Hill Hospital',
      url: 'https://www.kennedyhealth.org/?utm_source=jefferson&utm_medium=nav&utm_campaign=healthsystem&utm_content=cherryhill'
    },
    {
      id: 2,
      label: 'Jefferson Stratford Hospital',
      url: 'https://www.kennedyhealth.org/?utm_source=jefferson&utm_medium=nav&utm_campaign=healthsystem&utm_content=stratford'
    },
    {
      id: 3,
      label: 'Jefferson Washington Township Hospital',
      url: 'https://www.kennedyhealth.org/?utm_source=jefferson&utm_medium=nav&utm_campaign=healthsystem&utm_content=washtwp"'
    }
  ],
  careers: [
    {
      id: 1,
      label: 'Abington',
      url: 'https://www.abingtonhealth.org/JoinOurTeam/?utm_source=jefferson&utm_medium=nav&utm_campaign=healthsystem'
    },
    {
      id: 2,
      label: 'Aria',
      url: 'https://www.ariahealth.org/careers-education?utm_source=jefferson&utm_medium=nav&utm_campaign=healthsystem'
    },
    {
      id: 3,
      label: 'Jefferson',
      url: 'http://hr.jefferson.edu/human-resources/careers.html?utm_source=jefferson&utm_medium=nav&utm_campaign=healthsystem'
    },
    {
      id: 4,
      label: 'Kennedy',
      url: 'https://www.kennedyhealth.org/careers?utm_source=jefferson&utm_medium=nav&utm_campaign=healthsystem'
    },
    {
      id: 5,
      label: 'Magee',
      url: 'http://mageerehab.org/get-involved/careers/?utm_source=jefferson&utm_medium=nav&utm_campaign=healthsystem'
    }
  ],
  giveNow: [
    {
      id: 1,
      label: 'Abington',
      url: 'https://www.abingtonhealth.org/WaysOfGiving/',
    },
    {
      id: 2,
      label: 'Aria',
      url: 'https://w3.jefferson.edu/giving/aria.html'
    },
    {
      id: 3,
      label: 'Jefferson',
      url: 'https://w3.jefferson.edu/giving.cfm"'
    },
    {
      id: 4,
      label: 'Kennedy',
      url: 'https://www.kennedyhealth.org/giving-kennedy-health-care-foundation'
    },
    {
      id: 5,
      label: 'Magee',
      url: 'http://mageerehab.org/get-involved/fundraising-events/?utm_source=jefferson&utm_medium=givenav&utm_campaign=healthsystem'
    }
  ]
}
